import axios from 'axios';
import { getUrlForPlatform } from '../helpers/DataHelper';
const API_BASE_URL = process.env.REACT_APP_NODE_API_SERVICE

console.log("Node apis ---", API_BASE_URL)
export async function getRepositories(platform) {
    const response = await axios.post(API_BASE_URL + 'getRepositories', {
        platform
    });

    return response.data;
}

export async function getAllDevelopersFromRepo(repositoryId, loggedInUserDetails) {
    const allUsers = await axios.post(API_BASE_URL + "getAllDevelopersFromRepo", {
        repositoryId,
        loggedInUserDetails
    });

    return allUsers.data;
}

export async function getGitMetrics(platform, username, passkey, startDate, endDate, repository) {
    let url = getUrlForPlatform(platform);
    const response = await axios.post(API_BASE_URL + 'getGitMetrics', {
        platform, url, username, passkey, startDate, endDate, repository
    });

    return response.data;
}

export async function getGitMetricsFromDB(selectedParameters) {
    let gitMetricsData = await axios.post(API_BASE_URL + "getStatsForParams", selectedParameters);

    return gitMetricsData.data;
}
export async function saveFolderMappings(payload, loggedInUserDetails){
    let result = await axios.post(API_BASE_URL + "saveFolderMapping", {payload, loggedInUserDetails})
    return result.data;
}

export async function getMetricsForMonth(loggedInUserDetails) {
    let gitMetricsData = await axios.post(API_BASE_URL + "getMonthWiseLOC", {
        "loggedInUserDetails":loggedInUserDetails
    });

    return gitMetricsData.data;
}

export async function getWeeklyExceptionData(loggedInUserDetails, startOfWeek, endOfWeek, selectedFolder) {
    let weeklyExceptionData = await axios.post(API_BASE_URL + "getWeeklyLOCData", {
        "loggedInUserDetails": loggedInUserDetails,
        startOfWeek,
        endOfWeek,
        selectedFolder
    })
    return weeklyExceptionData;
}

export async function getPrComments(prIds) {
    let allPrComments = await axios.post(API_BASE_URL + "getPrComments", prIds);

    return allPrComments.data;
}

export async function getCommitDetails(commitIds) {
    let allCommitDetails = await axios.post(API_BASE_URL + "getCommitDetails", commitIds);

    return allCommitDetails.data;
}

export async function getFileLOCDetails(commitId) {
    let allCommitDetails = await axios.post(API_BASE_URL + "getFileWiseLOC", commitId);

    return allCommitDetails.data;
}

export async function getPrDetails(prAndState) {
    let allCommitDetails = await axios.post(API_BASE_URL + "getPrDetails", prAndState);

    return allCommitDetails.data;
}

export async function getFolderOptions(folderOwner) {
    let folderOptions = await axios.post(API_BASE_URL + "getFolderOptions", {
        folderOwner: folderOwner
      });

    return folderOptions.data;
}

export async function storeFolderOption(newfolder, loggedInUserDetails) {
    let folderOptions = await axios.post(API_BASE_URL + "storeFolderOption", {
        newfolder:newfolder,
        folderOwner: loggedInUserDetails.Name
      });

    return folderOptions.data;
}

export async function getCommitsInDateRangForDevelopersFromDB(selectedParameters) {
    let gitMetricsData = await axios.post(API_BASE_URL + "getCommitsForParams", selectedParameters);

    return gitMetricsData.data;
}

export async function getPRsInDateRangForDevelopersFromDB(selectedParameters) {
    let gitMetricsData = await axios.post(API_BASE_URL + "getPRsForParams", selectedParameters);

    return gitMetricsData.data;
}

export async function getExcludedPaths(repoId) {
    
    const response = await axios.post(API_BASE_URL + 'getExcludedPaths', {
        "repoId":repoId
    });
    return response.data;
}

export async function updateExcludedPaths(selectedRepoId,pathsArray) {
    
    const response = await axios.post(API_BASE_URL + 'updateExcludedPaths', {
        "selectedRepoId":selectedRepoId,
        "pathsArray": pathsArray
    });
    return response.data;
}

export async function loginToHrms(username, password) {
    const response = await axios.post(API_BASE_URL + 'proxy-login', {
        username,
        password
    });
    return response.data;
}